import React, { useEffect } from "react";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import SocialLn from "../components/service/SocialLn";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const SocialLinedin = () => {
  const location = useLocation();
  useEffect(() => {
    const { search } = location;
    if (!search) {
      window.scroll(0, 0);
    }
  }, []);
  return (
    <>
      <Helmet>
        <meta name="keywords" content="campaigns in Chennai,
      ppc campaign in Chennai,
      linkedin marketing in Chennai,
      linkedin ads in Chennai,
      linkedin ads in india,
      linkedin marketing in india,
      linkedin ads in Chennai,
      LinkedIn marketing agency in Chennai,
      LinkedIn marketing company in Chennai,
      Chennai's Best LinkedIn Management Agency,
      Top LinkedIn Advertising Services In Chennai,
      Top linkedin marketing company in Chennai,
      digital marketing linkedin,
      linkedin marketing service Chennai,
      linkedin marketing service India"/>
        <title>LinkedIn Ads with Expert LinkedIn Marketing Services</title>
        <meta
          name="description"
          content="Boost B2B growth with LinkedIn ads and professional LinkedIn marketing services designed to reach decision-makers, drive quality leads, and maximize ROI."
        />
      </Helmet>
      <div>
        <Navbar />
        <SocialLn />
        <Footer />
      </div>
    </>

  );
};

export default SocialLinedin;
